export default __webpack_public_path__ + "static/media/amf.341123c7.jpg";